import * as _ from 'lodash';
import React from 'react';
import Loadable from 'react-loadable';
import { Switch } from 'react-router-dom';
import ConferenceWrapper from '@components/Conference/ConferenceWrapper';

import EditableRoute from '@components/EditableRoute';
import PageWrapper from '@modules/virtualHelp/components/PageWrapper';

const Loading = () => <div />;

const VirtualHelpSessions = Loadable({
  loader: () => import('@modules/virtualHelp/pages/virtualHelpSessions'),
  loading: Loading,
});

const MeetingDetail = Loadable({
  loader: () => import('@modules/virtualHelp/pages/meeting'),
  loading: Loading,
});

export const prefix = '/prodigyVirtualHelp';

export const appRoutes = {};

export const pathToTitleAndComponent = {
  [prefix]: {
    title: 'Prodigy Help Sessions',
    component: VirtualHelpSessions,
  },
  [prefix + '/sessions']: {
    title: 'Prodigy Help Sessions',
    component: VirtualHelpSessions,
  },
  [prefix + '/meeting']: {
    title: 'Virtual Help Session',
    component: MeetingDetail,
  },
  ...appRoutes,
};

export const parseHeaderTitle = path => {
  const paths = Object.keys(pathToTitleAndComponent);
  const currentPath = paths.find(p => path.startsWith(p)); // skip '/' route

  return _.get(pathToTitleAndComponent[currentPath], `title`, '');
};

const VirtualHelpRoutes = props => (
  <PageWrapper {...props}>
    <ConferenceWrapper prefix={prefix} isHelpDesk={true} {...props}>
      <Switch>
        {Object.entries(pathToTitleAndComponent).map(
          ([path, { component }]) => (
            <EditableRoute exact key={path} path={path} component={component} />
          ),
        )}
      </Switch>
    </ConferenceWrapper>
  </PageWrapper>
);

export default VirtualHelpRoutes;
